export const autoSellQuality = [
  { name: '关闭', key: '' },
  { name: '普通', key: 'normal' },
  { name: '稀有', key: 'race' },
  { name: '低阶史诗', key: 'special' },
  { name: '史诗', key: 'epic' },
  { name: '独特', key: 'unique' },
  { name: '传说', key: 'legend' },
]

export const commonMailTitleList = ['BOSS击败奖励', '每日挑战奖励']
